/* Galeria de la ficha de unidad — Vendotractos.
 *
 * Todos los medios se renderizan de una vez y se muestra uno a la vez, para que
 * un video sea un <video> de verdad y no la miniatura de un video. Cambiar de
 * medio pausa el que estaba sonando.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-vt-galeria]').forEach(function (galeria) {
    var items = galeria.querySelectorAll('[data-vt-item]');
    var tiras = galeria.querySelectorAll('[data-vt-tira]');
    if (!items.length) return;

    function mostrar(indice) {
      items.forEach(function (item) {
        var activo = item.dataset.vtItem === String(indice);
        item.hidden = !activo;
        if (!activo) {
          var v = item.querySelector('video');
          if (v && !v.paused) v.pause();
        }
      });
      tiras.forEach(function (t) {
        t.setAttribute('aria-current', String(t.dataset.vtTira === String(indice)));
      });
    }

    galeria.addEventListener('click', function (evento) {
      var tira = evento.target.closest('[data-vt-tira]');
      if (tira) {
        mostrar(tira.dataset.vtTira);
        return;
      }

      // Ampliar: solo imagenes; en un video el clic es para reproducirlo.
      var img = evento.target.closest('img[data-vt-zoom]');
      if (!img) return;
      var dialogo = document.querySelector('[data-vt-zoom-dialog]');
      if (!dialogo || typeof dialogo.showModal !== 'function') return;
      dialogo.querySelector('[data-vt-zoom-img]').src = img.dataset.vtZoom;
      dialogo.querySelector('[data-vt-zoom-img]').alt = img.alt || '';
      dialogo.showModal();
    });

    // Flechas del teclado sobre las miniaturas
    galeria.addEventListener('keydown', function (evento) {
      if (evento.key !== 'ArrowLeft' && evento.key !== 'ArrowRight') return;
      var actual = galeria.querySelector('[data-vt-tira][aria-current="true"]');
      if (!actual) return;
      var i = Number(actual.dataset.vtTira);
      var siguiente = evento.key === 'ArrowRight' ? i + 1 : i - 1;
      if (siguiente < 0 || siguiente >= tiras.length) return;
      mostrar(siguiente);
      tiras[siguiente].focus();
      evento.preventDefault();
    });
  });

  var dialogo = document.querySelector('[data-vt-zoom-dialog]');
  if (dialogo) {
    dialogo.addEventListener('click', function (evento) {
      // Cerrar con el boton o tocando el fondo
      if (evento.target.closest('[data-vt-zoom-cerrar]') || evento.target === dialogo) {
        dialogo.close();
      }
    });
  }
})();
